import React from 'react';
import { TrainsType } from '../../apis/Transits.api';
import Close from './../../assets/images/close_btn.png';
import Line from './../../assets/images/bico_line.png';
import Conductor from './../../assets/images/bico_conductor.png';
import LineB from './../../assets/images/bico_line_b.png';
import ConductorB from './../../assets/images/bico_conductor_b.png';
import Ride from './../../assets/images/btn_force_get_ride.png';
import Message from './../../assets/images/btn_message.png';
import Bang from './../../assets/images/bico_bang.png';
import Exclamation from './../../assets/images/bico_exclamation_mark.png';
import { PostLocationForceRideApi } from '../../apis/LocationForceRide.api';
import { useNavigate } from 'react-router-dom';

interface props {
  detailDisp: TrainsType[];
  setDetailDisp: React.Dispatch<React.SetStateAction<TrainsType[] | undefined>>;
}
const detailHeight = 70;
const detailWidth = 220;

const GetBackColor = (course: number) => {
  switch (course) {
    case 1:
      return 'blue';
    case 2:
      return 'lightgray';
    case 3:
      return 'red';
    case 4:
      return 'orange';
    case 5:
      return '#32cd32';
  }
};

const GetLineImage = (data: TrainsType) => {
  if (data.data_status === 2) {
    return Bang;
  }

  if (data.course === 2) {
    return LineB;
  } else {
    return Line;
  }
};

const GetFontColor = (course: number) => {
  switch (course) {
    case 1:
    case 3:
      return 'silver';
    default:
      return 'black';
  }
};
const GetAxis = (
  defPos: number,
  pos: number,
  calcType: boolean,
  axis: number,
  count: number
): number => {
  const position = calcType === true ? defPos + pos : defPos - pos;
  // 詳細表示（上）
  if (axis === 1) {
    if (position < 0) {
      return 0;
    } else if (position + detailWidth >= 1920) {
      return defPos - (defPos + detailWidth - 1920);
    } else {
      return position;
    }
  }
  // 詳細表示（下）
  else if (axis === 2) {
    if (defPos - 190 - detailHeight <= 0) {
      if (count === 1) {
        return defPos - (180 - detailHeight * 2);
      }
      return position + detailHeight * count;
    } else {
      return position - detailHeight * count;
    }
  }
  return 0;
};

export const TrainDetail: React.FC<props> = (props) => {
  const DispDatas = props.detailDisp;
  const setDetailDisp = props.setDetailDisp;
  const navigate = useNavigate();
  const ForceRideOnClick = (trainNo: number) => {
    PostApi(trainNo);
  };

  const PostApi = async (trainNo: number) => {
    const response = await PostLocationForceRideApi(trainNo);
    return response;
  };

  return (
    <svg>
      <g>
        {/* 四角 */}
        <rect
          x={GetAxis(DispDatas[0].x, 100, false, 1, 0)}
          y={
            DispDatas[0].y - 180 - detailHeight <= 0
              ? DispDatas[0].y - (180 - detailHeight * 2)
              : GetAxis(
                  DispDatas[0].y,
                  180 - detailHeight,
                  false,
                  2,
                  DispDatas.length
                )
          }
          width={detailWidth}
          height={detailHeight * DispDatas.length}
          fill={GetBackColor(DispDatas[0].course)}
          fillOpacity='0.8'
        ></rect>
        {/* 上向き三角 */}
        {DispDatas[0].y - 180 - detailHeight <= 0 && (
          <path
            d={`${
              'M ' +
              (DispDatas[0].x + 20) +
              ' ' +
              //　右
              (DispDatas[0].y - 39) +
              ' L ' +
              (DispDatas[0].x - 20) +
              ' ' +
              // 左
              (DispDatas[0].y - 39) +
              ' L ' +
              DispDatas[0].x +
              ' ' +
              // 頂点
              (DispDatas[0].y - 60)
            }`}
            fill={GetBackColor(DispDatas[0].course)}
            fillOpacity='0.8'
          ></path>
        )}
        {/* 下向き三角 */}
        {DispDatas[0].y - 180 - detailHeight >= 0 && (
          <path
            d={`${
              'M ' +
              (DispDatas[0].x - 20) +
              ' ' +
              //左
              (DispDatas[0].y - 111) +
              ' L ' +
              DispDatas[0].x +
              ' ' +
              //頂点
              (DispDatas[0].y - 90) +
              ' L ' +
              (DispDatas[0].x + 20) +
              ' ' +
              //右
              (DispDatas[0].y - 111)
            }`}
            fill={GetBackColor(DispDatas[0].course)}
            fillOpacity='0.8'
          ></path>
        )}
        {DispDatas.map((train, i) => {
          return (
            <g key={'detail_' + i}>
              {
                <g>
                  <image
                    x={GetAxis(DispDatas[0].x, 100, false, 1, i) + 10}
                    y={
                      GetAxis(
                        DispDatas[0].y,
                        180 - detailHeight,
                        false,
                        2,
                        DispDatas.length - i
                      ) + 10
                    }
                    xlinkHref={GetLineImage(train)}
                  ></image>
                  <text
                    fontSize='18'
                    fontWeight='bold'
                    x={GetAxis(DispDatas[0].x, 100, false, 1, i) + 30}
                    y={
                      GetAxis(
                        DispDatas[0].y,
                        180 - detailHeight,

                        false,
                        2,
                        DispDatas.length - i
                      ) + 26
                    }
                    fill={GetFontColor(DispDatas[i].course)}
                  >
                    {DispDatas[i].train_no}
                  </text>
                  {DispDatas[i].obc_error_flg && (
                    <image
                      x={
                        GetAxis(DispDatas[0].x, 100, false, 1, i) +
                        62 +
                        10 * (DispDatas[i].train_no.toString().length - 3)
                      }
                      y={
                        GetAxis(
                          DispDatas[0].y,
                          180 - detailHeight,
                          false,
                          2,
                          DispDatas.length - i
                        ) + 11
                      }
                      xlinkHref={Exclamation}
                    ></image>
                  )}
                  <image
                    x={
                      GetAxis(
                        DispDatas[0].x,
                        100,

                        false,
                        1,
                        i
                      ) + 10
                    }
                    y={
                      GetAxis(
                        DispDatas[0].y,
                        180 - detailHeight,
                        false,
                        2,
                        DispDatas.length - i
                      ) + 40
                    }
                    xlinkHref={
                      DispDatas[0].course === 2 ? ConductorB : Conductor
                    }
                  ></image>
                  <text
                    fontSize='18'
                    fontWeight='bold'
                    x={GetAxis(DispDatas[0].x, 100, false, 1, i) + 30}
                    y={
                      GetAxis(
                        DispDatas[0].y,
                        180 - detailHeight,
                        false,
                        2,
                        DispDatas.length - i
                      ) + 56
                    }
                    fill={GetFontColor(DispDatas[i].course)}
                  >
                    {DispDatas[i].staff_name}
                  </text>

                  <image
                    x={GetAxis(DispDatas[0].x, 100, false, 1, i) + 150}
                    y={
                      GetAxis(
                        DispDatas[0].y,
                        180 - detailHeight,
                        false,
                        2,
                        DispDatas.length - i
                      ) + 30
                    }
                    cursor='pointer'
                    xlinkHref={Ride}
                    onClick={() => ForceRideOnClick(train.train_no)}
                  ></image>

                  <image
                    x={GetAxis(DispDatas[0].x, 100, false, 1, i) + 185}
                    y={
                      GetAxis(
                        DispDatas[0].y,
                        180 - detailHeight,

                        false,
                        2,
                        DispDatas.length - i
                      ) + 30
                    }
                    cursor='pointer'
                    xlinkHref={Message}
                    onClick={() =>
                      navigate('/message?trainNo=' + train.train_no.toString())
                    }
                  ></image>
                </g>
              }
            </g>
          );
        })}
        <image
          x={GetAxis(DispDatas[0].x, 100, false, 1, 0) + 190}
          y={
            DispDatas[0].y - 185 - detailHeight <= 0
              ? DispDatas[0].y - (185 - detailHeight * 2) - 5
              : GetAxis(
                  DispDatas[0].y,
                  185 - detailHeight,
                  false,
                  2,
                  DispDatas.length
                ) - 5
          }
          cursor='pointer'
          xlinkHref={Close}
          onClick={() => setDetailDisp(undefined)}
        ></image>
      </g>
    </svg>
  );
};
